<div class="basicrow f-black roboto-r f-reg m-top-ii text-center">
        <div class="shortcont">
            <div class="basicrow" *ngIf="requiredAccountUpdate==true">

                    <div class="updt-textcont roboto-r f-black">
                        <img class="advrt-icn" src="./../../../assets/images/icono_advertencia.png" width="100%">

                        <div class="basicrow f-big roboto-b">Actualiza tu Usuario y Contrase&ntilde;a</div>

                        <div class="basicrow m-top-ii">Estamos aplicando cambios que nos ayudar&aacute;n a unificar nuestros portales y mejorar tu experiencia de acceso.</div>
                    </div>

                    <div class="basicrow m-top-i">
                        <div class="logline full"></div>
                    </div>

                    <div class="basicrow m-top-i">
                        Ahora podr&aacute;s ingresar al portal Mi Claro o a la aplicaci&oacute;n m&oacute;vil Mi Claro PR App con un correo electr&oacute;nico o n&uacute;mero de tel&eacute;fono.
                    </div>

                    
                    <div class="basicrow m-top-i">
                        <label class="label-f">
                            &#42; Usuario Actual
                        </label>

                        <input class="inp-f off" [(ngModel)]="this.username">
                    </div>

                    <div class="basicrow m-top-i">
                        <label class="label-f">
                            &#42; Nuevo Usuario
                        </label>

                        <div class="basicrow rel">
                            <div class="ortxtcnt text-center f-reg roboto-r f-black">&oacute;</div>

                            <div class="row">
                                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                    <input class="inp-f updt-inp" placeholder="usuario@claropr.com" [(ngModel)]="this.newUserEmail">
                                </div>

                                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                    <input class="inp-f updt-inp" [(ngModel)]="this.defaultSubscriber"readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                
            </div>
            
            <div class="basicrow m-top-i" *ngIf="requiredAccountUpdate==true">
                <div class="logline full"></div>
            </div>

                <div class="basicrow f-big m-top">
                    Actualiza tu Contrase&ntilde;a
                </div>

                <div class="basicrow bg-gray-u-i allpads bordsdef m-top-ii roboto-b text-justify">
                    El cambio de contrase&ntilde;a s&oacute;lo es efectivo si llenas los tres campos previstos: anterior, nuevo y confirmaci&oacute;n, y presionas Guardar Cambios.
                </div>
                <!-- <div class="basicrow m-top text-justify">
                    La contrase&ntilde;a debe tener entre 8 y 10 caracteres, incluyendo un m&iacute;nimo de 2 n&uacute;meros, diferenciando entre may&uacute;sculas y min&uacute;sculas.
                </div> -->
            <div class="basicrow m-top-i">
                <div class="basicrow">
                    <label class="label-f">
                        &#42; Contrase&ntilde;a Actual
                    </label>

                    <input type="password" class="inp-f" placeholder="Escribe tu contrase&ntilde;a actual" [(ngModel)]="this.actualPassword">
                </div>

                <div class="basicrow m-top-i" style="float: left;">
                    <label class="label-f">
                        &#42; Nueva Contrase&ntilde;a
                    </label>

                    <input [(ngModel)]="this.password1" type="password" maxlength="10" placeholder="Escribe una nueva contrase&ntilde;a" class="inp-f" (keyup)="onKey($event)"  >
                    <app-password-validator></app-password-validator>
                </div>
                
                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; Confirmar Nueva Contrase&ntilde;a
                    </label>

                    <input type="password" placeholder="Confirma la nueva contrase&ntilde;a" class="inp-f" [(ngModel)]="this.password2">
                </div>
            </div>

            <div class="basicrow m-top-i">
                <div class="logline full"></div>
            </div>

            <div class="basicrow m-top-i text-center">
                <a  class="btns def-iv red centr vcenter">
                    <span class="tabcell"(click)="this.continuePassword()">
                        Guardar Cambios&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>